import { BaSeTheme } from "@base/react";
import React from "react";

export function handleModalAdmin({
  title,
  titleOnSuccess = "Sucesso",
  titleOnError = "Erro",
  content = "",
  showAPIErrorIfAvailable = false,
  msgOnSuccess = "Registro alterado com sucesso.",
  msgOnError = "Houve um erro ao tentar realizar essa ação, tente novamente.",
  onConfirmClick = () => {},
  onCancelClick = () => {},
  onFinish = () => {},
  showModal = (config) => {},
}) {
  const labelConfirm = "OK";
  const labelOk = "OK";
  const labelCancel = "Não";

  const successResponseConfig = {
    actions: [
      {
        action: labelOk,
        type: "primary",
        color: BaSeTheme.colors.feedbackInterface.sucesso20,
      },
    ],
    title: titleOnSuccess,
    titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
    dismissable: true,
    content: () => <p>{msgOnSuccess}</p>,
    onChooseAction: () => onFinish(),
  };
  const errorResponseConfig = (error) => {
    return {
      actions: [
        {
          action: labelOk,
          type: "primary",
          color: BaSeTheme.colors.feedbackInterface.informacao,
        },
      ],
      title: titleOnError,
      titleColor: BaSeTheme.colors.feedbackInterface.erro45,
      dismissable: true,
      content: () => (
        <p>{showAPIErrorIfAvailable && error ? error : msgOnError}</p>
      ),
      onChooseAction: () => onCancelClick(),
    };
  };

  const actionsMap = {
    [labelConfirm]: async () => {
      try {
        await onConfirmClick();
        showModal(successResponseConfig);
      } catch (e) {
        const errorData = errorResponseConfig(e?.response?.data?.message);
        showModal(errorData);
      }
    },
    [labelCancel]: () => onCancelClick(),
  };

  const actions = [
    {
      action: labelConfirm,
      type: "primary",
      color: BaSeTheme.colors.feedbackInterface.sucesso20,
    },
    {
      action: labelCancel,
      type: "primary",
      color: BaSeTheme.colors.feedbackInterface.erro45,
    },
  ];

  const config = {
    actions,
    title: title,
    titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
    dismissable: true,
    content: () => <p>{content}</p>,
    onChooseAction: (action) => actionsMap?.[action]?.(),
    onDismiss: () => onCancelClick(),
  };
  showModal(config);
}
